import React from 'react';
import { Activity, History, MessageSquareQuote, ListChecks, MessagesSquare } from 'lucide-react';
import FileManager from './FileManager';

interface DeveloperConsoleProps {
  selectedFileId: string | null;
  onFileSelect: (fileId: string | null) => void;
  onGoLoginActivity: () => void;
  onGoUsageHistory: () => void;
  onGoContactFaq: () => void;
  onGoContactSubjects: () => void;
  onGoContactHistory: () => void;
}

const DeveloperConsole: React.FC<DeveloperConsoleProps> = ({
  selectedFileId,
  onFileSelect,
  onGoLoginActivity,
  onGoUsageHistory,
  onGoContactFaq,
  onGoContactSubjects,
  onGoContactHistory,
}) => {
  return (
    <div className="developer-console">
      <div className="developer-console-intro">
        <h2>管理者コンソール</h2>
        <p>ファイルの登録、名称変更、削除はこの画面に限定されます。ここで登録したファイルが一般ユーザーに共有されます。</p>
        <div className="developer-console-actions">
          <button className="developer-console-action-button" onClick={onGoLoginActivity}>
            <Activity size={16} />
            ユーザログイン状況
          </button>
          <button className="developer-console-action-button" onClick={onGoUsageHistory}>
            <History size={16} />
            ユーザの利用履歴
          </button>
          <button className="developer-console-action-button" onClick={onGoContactFaq}>
            <MessageSquareQuote size={16} />
            FAQ見本管理
          </button>
          <button className="developer-console-action-button" onClick={onGoContactSubjects}>
            <ListChecks size={16} />
            件名候補管理
          </button>
          <button className="developer-console-action-button" onClick={onGoContactHistory}>
            <MessagesSquare size={16} />
            お問い合わせ履歴
          </button>
        </div>
      </div>

      <FileManager
        onFileSelect={onFileSelect}
        selectedFileId={selectedFileId}
        allowUpload={true}
        title="共有ファイル管理"
        description="Excel / CSV を登録し、公開中ファイルをメンテナンスします。"
      />
    </div>
  );
};

export default DeveloperConsole;
